module.exports = __webpack_public_path__ + "img/img20.579c5789.svg";